import React, { useEffect } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

const Toast = ({ visible, message, type = 'info', duration = 2500, onHide }) => {
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => { onHide && onHide(); }, duration);
    return () => clearTimeout(t);
  }, [visible, duration, onHide]);

  if (!visible || !message) return null;

  const bg = type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#334155';

  return (
    <View
      style={[
        styles.container,
        isWeb ? styles.webPos : styles.nativePos,
        { backgroundColor: bg },
      ]}
      pointerEvents="none"
      accessibilityLiveRegion="polite"
    >
      <Text style={styles.text}>{message}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
    boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
    zIndex: 2000,
    maxWidth: 360,
  },
  text: {
    color: '#ffffff',
    fontSize: 13,
    fontWeight: '600',
  },
  webPos: {
    position: 'fixed',
    right: 20,
    top: 20,
  },
  nativePos: {
    position: 'absolute',
    right: 12,
    top: 12,
  },
});

export default Toast;